module.exports = __webpack_public_path__ + "img/1f408.054cc74.svg";